import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Container,
  Row,
  Col,
  Dropdown} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Cookies from 'js-cookie'

import {
  FaCopy,
  FaIdCard} from 'react-icons/fa'
// import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import ApiEndpoints, { BASE_URL, BASE_URL_Upload } from './commonComponents/ApiEndpoints'
import { BsFunnelFill, BsSearch, BsArrowClockwise, BsEyeFill, BsThreeDotsVertical, BsPencilFill } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import toast from 'react-hot-toast'
import { Eye,  Person } from 'react-bootstrap-icons'
import { FaEyeSlash, FaEye } from 'react-icons/fa'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { Card } from 'react-bootstrap'
import { UserPlus } from 'react-feather'
import EditUser from './EditUser'

const AddUser = () => {
  const { user, token, logout } = useAuth()
  const { isCollapsed } = useSidebar()
  console.log('USER ', user)
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(20)
  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [loading, setLoading] = useState(false)
  const [allInstitute, setAllInstitute] = useState([])
  const [createdPassword, setCreatedPassword] = useState('');
  const [showCreatedPassword, setShowCreatedPassword] = useState(false);
  const [userImage, setUserImage] = useState(null)

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {

        // const userCookie = Cookies.get('user')
        //  let token = null

        //  if(userCookie){
        //    token = user.token
        //  }

        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId)}

        // console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL + '/get/users',
          { headers },
        )

        console.log('Users response: ', response.data)

        setData(response.data)
        // setFilteredData(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [loading])
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    phone_number: '',
    password: '',
    user_id: '',
    user_type: '',
    designation: ''})


  // Filter Data Based on Search
  const dataWithoutParents = (data || []).filter(
    (item) => (item?.user_type || '').toString().toLowerCase() !== 'parents',
  )

  const filteredData = dataWithoutParents.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
const totalPages = Math.ceil((filteredData?.length || 0) / itemsPerPage) || 1
 useEffect(() => {
  if (currentPage > totalPages && totalPages !== 0) {
    setCurrentPage(1)
  }
}, [filteredData, totalPages])


const indexOfLastItem = currentPage * itemsPerPage
const indexOfFirstItem = Math.max(indexOfLastItem - itemsPerPage, 0)
const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem) || []


// Fetch institutes
useEffect(() => {
  const fetchInstitutes = async () => {
    try {
      const res = await ApiEndpoints.getAllInstitutes()
      setAllInstitute(res.data.data)
    } catch (error) {
      console.error(error)
    }
  }
  fetchInstitutes()
}, [])

const handleInputChange = (e) => {
  const { name, value } = e.target;
   setNewUser((prev) => ({
    ...prev,
    [name]: value}))
};

  // Add New Teacher
  const handleSave = async (e) => {
    e.preventDefault()

    try {
      setLoading(true)

      let imageUrl = null
      if (userImage) {
        if (userImage.size > 2 * 1024 * 1024) {
          toast.error('Image size should not exceed 2MB.')
          setLoading(false)
          return
        }
        const instituteId = Number(Cookies.get('institute_id'))
        if (!instituteId) {
          toast.error('Institute is required for image upload.')
          setLoading(false)
          return
        }
        try {
          const formData = new FormData()
          formData.append('image', userImage)
          formData.append('folder', 'user')
          const imageResponse = await axios.post(
            BASE_URL + '/upload-image',
            formData,
          )
          if (imageResponse.data && imageResponse.data.path) {
            imageUrl = BASE_URL_Upload + `/${imageResponse.data.path}`
          } else {
            throw new Error('Image upload failed.')
          }
        } catch (logoErr) {
          toast.error(
            logoErr.response?.data?.message ||
              logoErr.message ||
              'Image upload failed.',
          )
          setLoading(false)
          return
        }
      }

      // const headers = {
      //   Authorization: `Bearer ${user.token}`,
      // }
      const phoneTrimmed = (newUser.phone_number || '').trim()
      const designationTrimmed = (newUser.designation || '').trim()
      const payload = {
      name:  newUser.name,
      email:  newUser.email,
      phone_number: phoneTrimmed || null,
      password:  newUser.password,
      institute_id: Number(Cookies.get('institute_id')),
      user_id:  newUser.user_id || null,
      user_type: newUser.user_type,
      designation: designationTrimmed || null,
      profile_img_url: imageUrl,
      }

      console.log('Sending data: ', newUser)
      const response = await axios.post(BASE_URL + "/create/user",payload,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      toast.success(response.data.message)
      
    // Store the created password so we can show it
    setCreatedPassword(newUser.password);
      setNewUser({
        name: '',
        email: '',
        phone_number: '',
        password: '',
        user_id: '',
        user_type: '',
        designation: ''})
      setUserImage(null)
      setShowModal(false)
    } catch (error) {
       // ✅ Handle validation & other API errors
    if (error.response?.data?.errors) {
      // Loop through all validation messages
      const allErrors = error.response.data.errors;
      Object.values(allErrors).forEach((errArr) => {
        errArr.forEach((msg) => toast.error(msg));
      });
    } else if (error.response?.data?.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Something went wrong. Please try again.");
    }

    setShowModal(true);

    } finally {
      setLoading(false)
    }
  }

  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(true)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const [showPassword, setShowPassword] = useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }
  const navigate = useNavigate()
  const assignUserRole = (item) => {
    navigate(`/Assign/UserRole/${item.id}`, {
      state: {
        userData: {
          id: item.id,
          name: item.name,
          email: item.email}}});
  };

  const handlePrintIdCard = (item) => {
    navigate('/user-profile', { state: { userData: item } })
  }

  const handleEditUser = (item) => {
    setSelectedUser(item)
    setShowEditModal(true)
  }

  const handleRefresh = async () => {
    setSearch('')
    setCurrentPage(1)
    // Reload users data
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    if (userCookie && institueId) {
      try {
        const user = JSON.parse(userCookie)
        const token = user.token
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId)}
        const response = await axios.get(
          BASE_URL + '/get/users',
          { headers },
        )
        setData(response.data || [])
      } catch (error) {
        console.error('Error fetching users:', error)
        toast.error('Failed to refresh users')
      }
    }
  }

  const refreshUsersAfterEdit = async () => {
    await handleRefresh()
  }

  const highlightText = (text, search) => {
    if (!search) return text

    const lowerText = text.toString().toLowerCase()
    const lowerSearch = search.toLowerCase()

    // Check if all characters from search exist in the text
    const allCharsMatch = [...lowerSearch].every((char) =>
      lowerText.includes(char),
    )

    if (!allCharsMatch) {
      // Return plain text if any character is missing
      return text
    }

    // Highlight matching characters
    return text
      .toString()
      .split('')
      .map((char, i) => {
        return lowerSearch.includes(char.toLowerCase()) ? (
          <span key={i} style={{ backgroundColor: 'yellow', color: 'black' }}>
            {char}
          </span>
        ) : (
          <span key={i}>{char}</span>
        )
      })
  }
  return (
    <>
      <style>
        {`
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }

          .table td {
            user-select: text;
            overflow: visible !important;
          }
          .table tbody tr {
            cursor: default;
            overflow: visible !important;
          }
          .dropdown-menu {
            z-index: 9999 !important;
            position: absolute !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add User Icon Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Manage Users
              </h3>
              {/* <button
                onClick={() => setShowModal(true)}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#223843',
                  border: 'none',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  flexShrink: 0}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New User"
              >
                <UserPlus size={18} />
              </button> */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Password Reference */}
          {createdPassword && (
            <div className="alert alert-info d-flex align-items-center justify-content-between p-2 mb-4" style={{ borderRadius: '8px' }}>
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <strong>Created user password, please note:</strong>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  value={createdPassword}
                  readOnly
                  style={{ maxWidth: "150px" }}
                />
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => navigator.clipboard.writeText(createdPassword)}
                  title="Copy Password"
                >
                  <FaCopy />
                </button>
              </div>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setCreatedPassword("")}
              ></button>
            </div>
          )}

          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="20">20 per page</option>
                  <option value="40">40 per page</option>
                  <option value="60">60 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>

            {/* Add New — desktop (mobile below, match CreateAnnouncement.js) */}
            <button
              type="button"
              className="d-none d-md-flex align-items-center justify-content-center"
              onClick={() => setShowModal(true)}
              style={{
                borderRadius: '10px',
                padding: '6px 10px',
                height: '44px',
                border: 'none',
                backgroundColor: '#223843',
                color: '#ffffff',
                gap: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1f323a'
                e.currentTarget.style.transform = 'scale(1.03)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#223843'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Add New User"
            >
              <UserPlus size={18} />
              <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                Add New User
              </span>
            </button>
          </div>

          <div className="d-md-none d-flex justify-content-end mb-4">
            <button
              type="button"
              onClick={() => setShowModal(true)}
              style={{
                borderRadius: '10px',
                padding: '6px 10px',
                height: '44px',
                border: 'none',
                backgroundColor: '#223843',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'}}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1f323a'
                e.currentTarget.style.transform = 'scale(1.03)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#223843'
                e.currentTarget.style.transform = 'scale(1)'
              }}
              title="Add New User"
            >
              <UserPlus size={18} />
              <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                Add New User
              </span>
            </button>
          </div>

          {/* Modern Filter Section */}
          <div 
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0'}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search Users
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find users quickly by name, email, or institute
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                  <Row className="g-3">
                    <Col xs={12}>
                      <div style={{ position: 'relative' }}>
                        <label className="fw-semibold text-start mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search User Name
                        </label>
                        <div style={{ position: 'relative' }}>
                          <BsSearch 
                            style={{ 
                              position: 'absolute', 
                              left: '12px', 
                              top: '50%', 
                              transform: 'translateY(-50%)',
                              color: '#6b7280',
                              fontSize: '16px',
                              zIndex: 1}} 
                          />
                          <Form.Control
                            type="text"
                            placeholder="Enter user name..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{
                              paddingLeft: '40px',
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              fontSize: '14px',
                              height: '40px',
                              transition: 'all 0.2s ease',
                              backgroundColor: '#ffffff',
                              fontFamily: 'Inter, system-ui, sans-serif'}}
                            onFocus={(e) => {
                              e.target.style.borderColor = '#223843'
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = '#D1D3D4'
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Table */}
        <Card className="table-card" style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'visible', backgroundColor: '#ffffff', position: 'relative' }}>
          <div className="table-wrapper" style={{ overflowX: 'auto', overflowY: 'visible', position: 'relative', borderRadius: '12px' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'visible', position: 'relative', marginBottom: '0' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Email</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Role</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Institute</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems?.length > 0 ? (
                currentItems?.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #E5E7EB'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{highlightText(item.name?.toUpperCase(), search)}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.email}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.user_type?.charAt(0).toUpperCase() + item.user_type?.slice(1)}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                      {
                        allInstitute.find(inst => inst.institute_id === item.institute_id)?.name || '-'
                      }
                    </Td>
                    <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                      {/* Desktop View - Dropdown */}
                      <div className="d-none d-md-block">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="light"
                            id={`dropdown-user-${item.id}`}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: 'transparent',
                              border: '1px solid #D1D3D4',
                              padding: '0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease'}}
                            className="dropdown-toggle-no-caret"
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.borderColor = '#223843'
                              e.currentTarget.style.color = '#ffffff'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent'
                              e.currentTarget.style.borderColor = '#D1D3D4'
                              e.currentTarget.style.color = '#111827'
                            }}
                          >
                            <BsThreeDotsVertical style={{ color: 'inherit' }} />
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              borderRadius: '8px',
                              border: '1px solid #D1D3D4',
                              padding: '8px',
                              minWidth: '180px'}}
                          >
                              <Dropdown.Item
                                  onClick={() => handleEditUser(item)}
                                  style={{
                                    fontSize: '13px',
                                    padding: '10px 12px',
                                    color: '#111827',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    transition: 'all 0.2s ease',
                                    borderRadius: '6px',
                                    fontFamily: 'Inter, system-ui, sans-serif'}}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#10B981'
                                    e.currentTarget.style.color = '#ffffff'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent'
                                    e.currentTarget.style.color = '#111827'
                                  }}
                                >
                                  <BsPencilFill size={18} /> Update User
                                </Dropdown.Item>

                            <Dropdown.Item
                              onClick={() => assignUserRole(item)}
                              style={{
                                fontSize: '13px',
                                padding: '10px 12px',
                                color: '#111827',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'all 0.2s ease',
                                borderRadius: '6px',
                                fontFamily: 'Inter, system-ui, sans-serif'}}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsEyeFill size={18} /> Manage Role
                            </Dropdown.Item>

                            <Dropdown.Item
                              onClick={() => handlePrintIdCard(item)}
                              style={{
                                fontSize: '13px',
                                padding: '10px 12px',
                                color: '#111827',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                transition: 'all 0.2s ease',
                                borderRadius: '6px',
                                fontFamily: 'Inter, system-ui, sans-serif'}}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <FaIdCard size={18} /> Print Id Card
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                      {/* Mobile View - Circular Buttons */}
                      <div className="d-md-none d-flex justify-content-start gap-2">
                        
                      <button
                          onClick={() => handleEditUser(item)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: '#10B981',
                            border: 'none',
                            color: '#FFFFFF',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer'}}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#D97706'
                            e.currentTarget.style.transform = 'scale(1.05)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#F59E0B'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title="Update User"
                        >
                          <BsPencilFill size={16} color="#FFFFFF" />
                        </button>
                        <button
                          onClick={() => assignUserRole(item)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: '#223843',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer'}}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title="Manage Role"
                        >
                          <BsEyeFill size={16} />
                        </button>
                        <button
                          onClick={() => handlePrintIdCard(item)}
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: '#223843',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer'}}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'scale(1.1)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title="Print Id Card"
                        >
                          <FaIdCard size={16} />
                        </button>
                      </div>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="4" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          </div>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData?.length || 0}
          itemLabel="users"
        />
        </div>
      </div>

      {/* Add New User Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
          <Modal.Title>Add New User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Name Field */}
            <Form.Group className="mb-3">
              <Form.Label>Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newUser.name}
                onChange={handleInputChange}
                placeholder="Enter User's Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            {/* Email ID Field */}
            <Form.Group className="mb-3">
              <Form.Label>Email ID *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={newUser.email}
                onChange={handleInputChange}
                placeholder="Enter Email"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone number</Form.Label>
              <Form.Control
                type="tel"
                name="phone_number"
                value={newUser.phone_number}
                onChange={handleInputChange}
                placeholder="Enter phone number"
                className="p-2 border rounded"
                inputMode="tel"
                autoComplete="tel"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>User Type *</Form.Label>
              <Form.Select
                name="user_type"
                value={newUser.user_type}
                onChange={(e) => {
                  const value = e.target.value
                  setNewUser((prev) => ({
                    ...prev,
                    user_type: value}))
                }}
                required
              >
                <option value="">Select</option>
                <option value="admin">Admin</option>
                <option value="accountant">Accountant</option>
                <option value="staff">Staff</option>
                <option value="fees_collector">Fee Collector</option>
                <option value="marketer">Marketer</option>
                <option value="bus_attendant">Bus Attendant</option>
              </Form.Select>
              <Form.Text className="text-muted" style={{ fontSize: '12px' }}>
                Extra access (students, courses, classes, guardians, announcements, exams) can be
                granted after the user is created via <strong>Manage role</strong> on the user list.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Designation (Optional)</Form.Label>
              <Form.Control
                type="text"
                name="designation"
                value={newUser.designation}
                onChange={handleInputChange}
                placeholder="Enter designation"
                className="p-2 border rounded"
              />
            </Form.Group>

            {/* <Form.Group className="mb-3">
              <Form.Label>User Id</Form.Label>
              <Form.Control
                type="text"
                name="user_id"
                value={newUser.user_id}
                onChange={handleInputChange}
                placeholder="Enter User ID"
                required
              />
            </Form.Group> */}

            <Form.Group className="mb-3 mt-3">
              <Form.Label>Password *</Form.Label>
              <div className="input-group">
                <Form.Control
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={newUser.password}
                  onChange={handleInputChange}
                  placeholder="Enter Password"
                  className="p-2 border rounded"
                  required
                />
                <Button
                  variant="outline-secondary"
                  onClick={togglePasswordVisibility}
                  title={showPassword ? 'Hide Password' : 'Show Password'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </Button>
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>User Image (PNG/JPG/JPEG)</Form.Label>

              <div className="d-flex align-items-center gap-3 mt-2 mb-2">
                <Form.Control
                  type="file"
                  accept="image/png, image/jpeg, image/jpg"
                  onChange={(e) => setUserImage(e.target.files[0])}
                  style={{ maxWidth: '700px' }}
                />
                {userImage && (
                  <img
                    src={URL.createObjectURL(userImage)}
                    alt="Preview"
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: 'cover',
                      borderRadius: 8,
                      border: '1px solid #ccc'}}
                  />
                )}
              </div>
            </Form.Group>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button variant="success" type="submit">
                Save User
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>

      <EditUser show={showEditModal} handleClose={() => setShowEditModal(false)} user={selectedUser} onUserUpdated={refreshUsersAfterEdit} />
    </>
  )
}

export default AddUser
